import { render, staticRenderFns } from "./DiscussionHistory.vue?vue&type=template&id=8da4b612&scoped=true&"
import script from "./DiscussionHistory.vue?vue&type=script&lang=js&"
export * from "./DiscussionHistory.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionHistory.vue?vue&type=style&index=0&id=8da4b612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da4b612",
  null
  
)

export default component.exports